import { markRaw } from 'vue'
import PortalView from './PortalView.vue'
import schema from './schema'

export default {
  viewComponent: markRaw(PortalView),
  editorSchema: schema,
  editorData: {
    targetBlockUuid: '',
  },
}
